import styles from './quiz-style.module.scss';

type QuizButtonProps = {
  text: string;
  link?: string;
  onClick?: () => void;
  icon?: () => JSX.Element | null;
};

function QuizButton({
  text,
  link,
  icon = () => null,
  onClick,
}: QuizButtonProps): JSX.Element {
  // If no link is provided, this means the button is used for a quiz that renders secondary actions.
  if (!link) {
    return (
      <button className={styles.quizButton} onClick={onClick}>
        {icon ? icon() : null}
        {text}
      </button>
    );
  }

  return (
    <a
      href={link}
      target="_blank"
      className={styles.quizButton}
      onClick={onClick}
    >
      {icon ? icon() : null}
      {text}
    </a>
  );
}

export default QuizButton;
